import type { ComponentProps, ReactNode } from 'react'
import { cn } from './cn'

/**
 * Customer inputs are white pills (DESIGN.md), at least 44 px tall. The edge
 * uses the muted text colour: --color-border is 1.35:1 on white, under the 3:1
 * WCAG 1.4.11 asks of a control's boundary, so fields vanished in sunlight.
 * Under the pointer the edge turns brand blue, as a button's does; focus adds
 * the ring (theme.css).
 */
const control =
  'min-h-touch w-full rounded-control border border-text-muted bg-bg px-4 text-base text-text transition-colors hover:border-brand aria-invalid:border-danger aria-invalid:hover:border-danger disabled:bg-surface disabled:hover:border-text-muted'

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(control, className)} {...props} />
}

export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(control, 'pr-8', className)} {...props} />
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(control, 'rounded-card px-4 py-3 leading-body', className)}
      {...props}
    />
  )
}

/** A native checkbox with its label; the whole row is the hit area. */
export function Checkbox({
  className,
  label,
  ...props
}: Omit<ComponentProps<'input'>, 'type'> & { label: ReactNode }) {
  return (
    <label className={cn('flex min-h-touch cursor-pointer items-start gap-3 py-2', className)}>
      <input type="checkbox" className="mt-1 size-6 shrink-0 accent-brand" {...props} />
      <span className="text-base text-text">{label}</span>
    </label>
  )
}
